export default function ($stateProvider) {
	"ngInject";
    $stateProvider.state('surveyWithSlash', {
        url: '/s/:surveyKey/?lang&i',
        template: `<survey-with-slash></survey-with-slash>`
    });
}


// WEBPACK FOOTER //
// ./app/components/survey-with-slash/survey-with-slash.config.js